<script setup lang="ts">
import { Vue3Marquee } from 'vue3-marquee'
import type { Image } from '@/types/ReverseSlider'

const props = defineProps({
	imgArray: {
		type: Array as () => Image[],
		default: () => [],
	},
})
</script>

<template>
	<Vue3Marquee>
		<div class="mx-12px" v-for="img in imgArray" :key="img.src">
			<img class="h-[153px] mdp:h-[240px] mdl:h-[303px]" :src="img.src" />
		</div>
	</Vue3Marquee>
</template>
